import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IDisplay {
    displayType: string[];
    questions: string[];
    decimal: string;
}

interface IDataAnalyticsDisplay {
    display: IDisplay;
}

const initialState: IDataAnalyticsDisplay = {
    display: {
        displayType: [],
        questions: [],
        decimal: '',
    },
};

const dataAnalyticsDisplaySlice = createSlice({
    name: 'dataAnalyticsDisplay',
    initialState,
    reducers: {
        setDisplay: (state, action: PayloadAction<IDisplay>) => {
            state.display = action.payload;
        },
    },
});

export const { setDisplay } = dataAnalyticsDisplaySlice.actions;

export default dataAnalyticsDisplaySlice.reducer;
